module.exports = __webpack_public_path__ + "static/img/RS1566_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RS1566_1.png
// module id = SXr0
// module chunks = 0